import { Footer } from 'src/shared/components/Footer'
import { PageContainer } from 'src/shared/components/PageContainer'
import { ProductsPage } from 'src/pages/Products'
import { MosaicSectionHeader } from './components/MosaicSectionHeader'
import { OurProductsHero } from './components/OurProductsHero'

export const OurProductsPage = () => {
  return (
    <>
      <PageContainer width="lg" className="gap-12 py-8">
        <OurProductsHero />

        <MosaicSectionHeader />

        <ProductsPage
          asSection
          showFooter={false}
          showAddToQuote={false}
        />
      </PageContainer>

      <div className="mt-8">
        <Footer />
      </div>
    </>
  )
}
